const styles = theme => ({

    mainGrid:{
        margin: "7% 0 0 2% !important", 
        width:'100% !important'
    },

    textGrid:{
        margin:'0px 0px 50px 0px !important'
    },

    inputColor : {
        color:'#ffffff !important'
    },

    campaignText: {
        color: '#FFF ! important',
        fontFamily: 'cardiuma-M ! important',
        fontSize: '34px ! important',
        fontStyle: 'normal',
        fontWeight: '500 ! important',
        lineHeight: '20px ! important'
    },

    flexgrids: {
        display:'flex !important',
        marginTop:'20px !important'
    },

    subgrids:{
        display:'flex !important',
        flexDirection: 'column !important'
    },


    select :{
        color : '#ffffff !important',
        width: '210px !important',
        background : '#131E2E',
      },
    
    typeGrid : {
        display:'flex !important',
        justifyContent:'left !important',
        alignItems:'center !important'
    },
    uploadGrid : {
        display:'flex !important',
        alignItems:'center !important',
        marginLeft: '20px !important'
    },
    uploadSubGrid:{
        display:'flex !important',
        flexDirection:'column !important',
    },

    chooseButton : {
        backgroundColor:'rgb(244, 71, 72) !important',
        padding:'9px 15px 9px 15px !important',
        fontSize:'12px !important'
    },

    sendbutton:{
        margin:'0px 0px 0px 20px', 
    },


    button : {
        gap: "2px !important",
        color: "rgb(255, 255, 255) !important",
        backgroundColor: "rgb(244, 71, 72) !important",
        fontFamily: "cardiuma-regular !important",
        fontSize: "12px !important",
        fontStyle: "normal !important",
        BorderRadius: '4px !important',
        padding:'9px 15px 9px 15px !important',
    },
    disabledButton :{ 
            color: "#ffffff !important",
            backgroundColor: "#999999 !important",
            fontFamily: "cardiuma-regular !important",
            fontSize: "12px !important",
            fontStyle: "normal !important",
            BorderRadius: '4px !important',
            padding:'9px 15px 9px 15px !important',

    },

    chooseText: {
        color: "#ffffff !important", 
        marginLeft:'10px !important',
        fontSize:'14px !important',
        fontFamily: "cardiuma-M !important",
    },

    previewGrid : {
        width:'60% !important',
        
        "@media only screen and (max-width: 1510px)": {
            width:'75% !important',
        },
    },
    previewGrid1 : {
        width:'98% !important',
    },

    fileHeading : {
        color: "#ffffff", 
        marginTop:'25px !important', 
        textAlign:'center !important', 
        fontFamily: 'cardiuma-Bold ! important',
        fontSize:'20px !important'
    },

    previewText:{
    color:'#999999 !important', 
    fontFamily: 'cardiuma-M !important'
    },

    prevRows : {
        color: "#ffffff !important", 
        marginTop:'5px !important',  
        textAlign:'center !important',  
        fontFamily: 'cardiuma-regular ! important',
        fontSize:'15px !important'
    },

    prevGrid:{
        display:'flex !important', 
        justifyContent:'start !important'
    }, 

    prevTableHead : {
        backgroundColor:'#131e2e !important', 
        borderColor:'black !important'
    },

    prevTableCell : {
        color:'#747474 !important', 
        borderBottom: '2px solid black !important'
    },

    prevTableBody :{
        backgroundColor:'#131e2e !important', 
        borderColor:'black !important'
    },

    prevTableBodyCell : {
         color:'#ffffff !important', 
         borderBottom: '2px solid black !important'
    },

    alertbox : {
        display:'flex !important', 
        justifyContent:'center !important', 
        marginTop:'20px !important'
    },

    dialogTitle :{ 
        textAlign:'center !important', 
        paddingTop:'0px !important', 
        paddingBottom:'10px !important'
    },

    dialogContentText : {
        textAlign:'center !important', 
        padding:'0px 20px 10px 20px !important'
    },

    dialogAction : {
        display:'flex !important', 
        justifyContent:'center !important'
    },
    //dev-trupti on 11-12-2024
    syncButton : {
        marginLeft: '20px !important'
    }
})

export default styles